<div class="go-footer">
  <ng-content></ng-content>
</div>
